module.exports = __webpack_public_path__ + "static/media/IMG_9127-min.0b2a1f3c.jpg";